/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PaymentInitDataApiModel {
  /**
   * Payment amount
   */
  amount: number;
  /**
   * Automaticaly finalize transactions when payment completed successfuly
   */
  auto_finalize_parent_transaction?: boolean;
  /**
   * Card Id
   */
  card_id: string;
  /**
   * Card password
   */
  card_password?: string;
  /**
   * Payment Id
   */
  id: string;
  /**
   * Integration type used for payment (for Stripe only)
   */
  integration_type?: PaymentInitDataApiModelIntegrationTypeEnum;
  /**
   * Redirect URL if payment canceled
   */
  redirect_cancel_url?: string;
  /**
   * Redirect URL if payment failed
   */
  redirect_fail_url?: string;
  /**
   * Redirect URL if payment successful
   */
  redirect_success_url?: string;
  /**
   * Save card for future use (for Stripe only)
   */
  save_for_future_use?: boolean;
}
export enum PaymentInitDataApiModelIntegrationTypeEnum {
  Checkout = 'checkout',
  Elements = 'elements'
}
